import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';

/**
 * Internal dependencies
 */
import { MOBILE_CONTENT } from '@constants';
import json from './block.json';
import icons from '../icons';
const { name, ...settings } = json;

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType(name, {
  ...settings,
  icon: icons.mobileContentWrapper,
  edit: (props) => {
    const { context, clientId } = props;
    const activeTab = context['b3rg/activeTab'];
    const enableMobileTab = context['b3rg/enableMobileTab'];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const blockProps = useBlockProps();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const innerBlockObj = useSelect(
      (select) => select('core/block-editor').getBlock(clientId).innerBlocks,
    );

    // Allowed inner blocks are decided based on the following array of patterns
    const allowedBlockPatterns = MOBILE_CONTENT.ALLOWED_BLOCK_PATTERNS;
    const allowedBlockTypes = wp.blocks
      .getBlockTypes()
      .map(({ name }) => name)
      .filter((blockName) =>
        allowedBlockPatterns.some((v) => blockName.includes(v)),
      );

    // Limits the number of blocks to be used as top-level inner blocks to 1
    const appenderToUse = () =>
      innerBlockObj.length < 1 ? <InnerBlocks.ButtonBlockAppender /> : false;

    return (
      <div {...blockProps}>
        {activeTab === 'mobile' && enableMobileTab && (
          <InnerBlocks
            templateLock={false}
            renderAppender={() => appenderToUse()}
            allowedBlocks={allowedBlockTypes}
          />
        )}
      </div>
    );
  },

  save: () => {
    return <InnerBlocks.Content />;
  },
});
